export const getInitials = (name) => {
    const cleaned = String(name ?? "").trim();
    if (!cleaned) return "??";
    const parts = cleaned.split(/\s+/).filter(Boolean);
    const initials = parts
      .slice(0, 2)
      .map((p) => p[0]?.toUpperCase())
      .filter(Boolean)
      .join("");
    return initials || "??";
};

/**
 * Unique tagged people from `user:` mentions (first occurrence order).
 * The API stores one entry per person, not one per @ in the text — dedupe here so the
 * payload matches the create response.
 */
export const parseTaggedPeople = (markupValue) => {
    const seen = new Set();
    const tagged = [];
    const re = /@\[([^\]]+)\]\(user:(\d+)\)/g;
    let m;
    while ((m = re.exec(markupValue)) !== null) {
      const id = Number(m[2]);
      if (seen.has(id)) continue;
      seen.add(id);
      tagged.push({ id, name: m[1] });
    }
    return tagged;
}

/** Plain text with @DisplayName for user mentions; @email for email mentions. */
export const mentionMarkupToPlainText = (markupValue) => {
    return String(markupValue ?? "")
      .replace(/@\[([^\]]+)\]\(user:\d+\)/g, "@$1")
      .replace(/@\[([^\]]+)\]\(email:([^)]+)\)/g, "@$2");
}

/**
 * Review/Assignees returns `{ id: number, name: string }[]`.
 * react-mentions expects `{ id, display }`.
 */
export const mapAssigneesToMentionData = (raw) => {
    return raw
      .map((item) => ({
        id: String(item.id ?? ""),
        display: String(item.name ?? "").trim(),
      }))
      .filter((x) => x.id && x.display);
  };